Px.CMS.QRCode = class QRCode extends HTMLElement {

  static get observedAttributes() {
    return [
      'error-correction-level',
      'size'
    ];
  }

  constructor() {
    super();

    this.handleContentChange = this.handleContentChange.bind(this);

    this.attachShadow({mode: 'open'});

    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = `
      :host {
        display: inline-block;
      }
      svg {
        display: block;
        fill: currentColor;
        max-height: 100%;
        max-width: 100%;
      }
    `;

    this.shadowRoot.appendChild(style);

    this.svg_root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this.svg_path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    this.svg_root.appendChild(this.svg_path);

    this.shadowRoot.appendChild(this.svg_root);

  }

  connectedCallback() {
    this.handleContentChange();
    this.mutation_observer = new MutationObserver(this.handleContentChange);
    this.mutation_observer.observe(this, {childList: true, subtree: true, characterData: true});
  }

  disconnectedCallback() {
    this.mutation_observer.disconnect();
  }

  attributeChangedCallback() {
    this.handleContentChange();
  }

  handleContentChange() {
    const ec_level = this.getAttribute('error-correction-level') || QRCode.DEFAULT_ERROR_CORRECTION_LEVEL;
    const qrcode = JSQRCode(0, ec_level);
    qrcode.addData(this.textContent, 'Byte');
    qrcode.make();

    const module_count = qrcode.getModuleCount();

    this.svg_root.setAttribute('viewBox', `0 0 ${module_count} ${module_count}`);

    this.svg_path.setAttribute('d', qrcode.toSVGPath());

    const size = parseInt(this.getAttribute('size'), 10) || QRCode.DEFAULT_SIZE;
    this.svg_root.setAttribute('width', `${size}px`);
    this.svg_root.setAttribute('height', `${size}px`);
  }

};

Px.CMS.QRCode.DEFAULT_ERROR_CORRECTION_LEVEL = 'M';
Px.CMS.QRCode.DEFAULT_SIZE = 200;

customElements.define('px-qrcode', Px.CMS.QRCode);
